export function getBenchmarkOpsHubLink(
  projectId: string,
  benchmarkId?: string,
  useDetailPage?: boolean,
) {
  if (useDetailPage) {
    return `/genai-ops-hub/projects/${projectId}/quality/benchmark-center/project-benchmarks${
      benchmarkId ? `/detail/${benchmarkId}` : ''
    }`;
  }
  return `/genai-ops-hub/projects/${projectId}/quality/benchmark-center/project-benchmarks${
    benchmarkId ? `?benchmarkId=${benchmarkId}` : ''
  }`;
}

export function getBenchmarkOpsHubConfigLink(projectId: string) {
  return `/corp/genai-ops-hub/projects/${projectId}/quality/benchmark-center/project-benchmarks`;
}
